import { useEffect, useId, useRef, useState } from "react"
import mermaid from "mermaid"

let initialized = false
function ensureInitialized(): void {
  if (!initialized) {
    mermaid.initialize({ startOnLoad: false, theme: "default", securityLevel: "strict" })
    initialized = true
  }
}

interface MermaidDiagramProps {
  code: string
}

export function MermaidDiagram({ code }: MermaidDiagramProps): JSX.Element {
  const rawId = useId()
  const renderId = `mermaid-${rawId.replace(/[^a-zA-Z0-9]/g, "")}`
  const containerRef = useRef<HTMLDivElement>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    ensureInitialized()

    mermaid
      .render(renderId, code)
      .then(({ svg }) => {
        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = svg
          setError(null)
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Failed to render diagram")
        }
      })

    return () => {
      cancelled = true
    }
  }, [code, renderId])

  if (error) {
    return (
      <pre className="mermaid-error rounded-md bg-red-50 p-3 text-xs text-red-700">
        <code>{code}</code>
      </pre>
    )
  }

  return <div className="mermaid-diagram my-3 flex justify-center" ref={containerRef} data-testid="mermaid-diagram" />
}
